import PropTypes from 'prop-types';
import './_Paragraph.scss';

export const Paragraph = ({ text, size = '', position = '' }) => (<span className={`paragraph paragraph--${size} paragraph--${position}`}>{text}</span>);

Paragraph.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.string,
  position: PropTypes.string,
};
